<template>
  <div id="missing-fields">
    <div v-show="hasMissingCandidateFields">
      <p class="alert alert-info col-lg-8" v-html="$t('OfferContract.missingFields.candidate')"></p>
      <div v-for="candidateField in candidateFields">
        <div v-if="candidateField.value_type == 'civility'">
          <div class="form-group form-group-default form-multiselect col-lg-7" :class="{ 'form-group-ie': isIE }">
            <label>{{ candidateField.translated_field }}</label>
            <multiselect
              v-model="candidateField.value"
              :options="civilityOptions"
              :searchable="false"
              :placeholder="$t('multiselect.civility')"
              :showLabels="false"
              :allow-empty="true">
            </multiselect>
          </div>
        </div>
        <div v-else-if="candidateField.value_type == 'date'">
          <div class="d-flex flex-row align-items-center col-lg-7">
            <label class="mr-4 col-lg-4">{{ candidateField.translated_field }}</label>
            <date-picker v-model="candidateField.value" :datepickerOptions="datepickerDefaultOptions" :disabledToday="true" />
          </div>
        </div>
        <div v-else>
          <div class="form-group form-group-default required col-lg-7">
            <label>{{ candidateField.translated_field }}</label>
            <div class="controls">
              <input v-model="candidateField.value"
                     v-validate="'required'"
                     type="text"
                     name="field"
                     class="form-control"
                     aria-required="true">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="hasMissingOfferFields">
      <p class="alert alert-info col-lg-8" v-html="$t('OfferContract.missingFields.offer')"></p>
      <div v-for="offerField in offerFields">
        <div v-if="offerField.value_type == 'replacement_motive'">
          <div class="form-group form-group-default form-multiselect required col-lg-7" :class="{ 'form-group-ie': isIE }">
            <label>{{ offerField.translated_field }}
              <span class="multiple-offer-notice" v-html="$t('OfferContract.missingFields.multiple_offer_variable_message')"></span>
            </label>
            <multiselect v-model="offerField.value"
                         track-by="id"
                         label="name"
                         :options="replacementMotivesOptions"
                         :placeholder="$t('multiselect.placeholder')"
                         :showLabels="true"
                         :allow-empty="false"
                         deselectLabel="X"
                         selectedLabel="X"
                         selectLabel=""
                         data-vv-name="replacement_motive">
              <span slot="noResult">{{ $t("multiselect.no_result") }}</span>
            </multiselect>
          </div>
        </div>
        <div v-else-if="offerField.value_type == 'date'">
          <div class="d-flex flex-row align-items-center col-lg-7">
            <label class="mr-4 col-lg-4">{{ offerField.translated_field }}</label>
            <date-picker v-model="offerField.value" :datepickerOptions="datepickerDefaultOptions" />
          </div>
        </div>
        <div v-else-if="offerField.value_type == 'replacement_motive_details'">
          <div class="form-group form-group-default required col-lg-7">
            <label>{{ offerField.translated_field }}
              <span v-if="offerField.is_multiple_offer_variable" class="multiple-offer-notice" v-html="$t('OfferContract.missingFields.multiple_offer_variable_message')"></span>
            </label>
            <textarea v-model="offerField.value"
                      v-validate="'required'"
                      type="text"
                      name="field"
                      class="form-control"
                      rows="3">
            </textarea>
          </div>
        </div>
        <div v-else>
          <div class="form-group form-group-default required col-lg-7">
            <label>{{ offerField.translated_field }}
              <span class="multiple-offer-notice" v-html="$t('OfferContract.missingFields.multiple_offer_variable_message')"></span>
            </label>
            <div class="controls">
              <input v-model="offerField.value"
                     v-validate="'required'"
                     type="text"
                     name="field"
                     class="form-control"
                     aria-required="true">
            </div>
          </div>
        </div>
      </div>
    </div>

    <button @click="validateEnteredValues" class="btn btn-primary btn-cons m-t-10 btn-publish" :disabled="hasUpdatedFieldsEmpty">
      {{ $t("OfferContract.update_fields_button") }}
    </button>
  </div>
</template>

<script type="text/javascript">
import DatePicker from '@/components/pages/DatePicker'
import ie_mixin from '@/mixin/ie'
import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'OfferContractMissingFields',
    props: ['missingFields'],
    mixins: [ie_mixin],
    components: { DatePicker },
    data() {
      return {
        candidateFields: [],
        offerFields: [],
        civilityOptions: [this.$i18n.t("models.user.mrs"), this.$i18n.t("models.user.mr")],
        datepickerDefaultOptions: {
          startDate: new Date(1900, 1, 1)
        }
      }
    },

    computed: {
      ...mapGetters({
        replacementMotivesOptions: 'replacementMotives/replacementMotives'
      }),
      hasMissingCandidateFields() {
        return this.candidateFields.length > 0;
      },
      hasMissingOfferFields() {
        return this.offerFields.length > 0;
      },
      hasUpdatedFieldsEmpty() {
        var updatedFields = this.offerFields.concat(this.candidateFields)
        var values = updatedFields.map(field => field.value)
        return values.includes(null) || values.includes('')
      }
    },

    mounted() {
      this.hydrateFields(this.missingFields)
      this.initReplacementMotivesAction();
    },

    watch: {
      missingFields: (newFields) => {
        this.hydrateFields(newFields)
      }
    },

    methods: {
      ...mapActions({
        initReplacementMotivesAction: 'replacementMotives/initReplacementMotives',
      }),
      hydrateFields(missingFields) {
        missingFields.forEach((field) => {
          switch (field.model) {
            case 'candidate':
              this.candidateFields.push(field);
              break;
            case 'offer':
              this.offerFields.push(field);
              break;
          }
        })
      },
      validateEnteredValues() {
        var updatedFields = {candidate: {}, offer: {} };
        this.candidateFields.forEach((field) => {
          updatedFields['candidate'][field.name] = field.value
        });
        this.offerFields.forEach((field) => {
          updatedFields['offer'][field.name] = field.value
        });
        this.$emit('validateEnteredValues', updatedFields)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #missing-fields {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .multiple-offer-notice {
    text-transform: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/OfferContractMissingFields.vue